export function isFlutterItem(item, destinationId) {
  try {
    const url = new URL(item.article.url);
    return item.kind === "flutter-item" && typeof item.sourcePublication.id === "string" && Boolean(item.sourcePublication.id)
      && item.sourcePublication.id !== destinationId
      && [item.sourcePublication.name, item.article.id, item.article.headline, item.article.authorName].every(value => typeof value === "string" && value.trim())
      && url.protocol === "https:" && !url.username && !url.password;
  } catch { return false; }
}
